module.exports = {
  dateFormat: 'dd/mm/yyyy',
  loading: 'Loading',
  or: 'or',
  navigation: {
    'advisory-tool': 'Home',
    systems: 'Systems',
  },
  vat: {
    excluded: 'excl. btw',
    included: 'incl. btw',
  },
  validation: {
    maxCharacters: 'max. {amount} characters',
  },
};



// WEBPACK FOOTER //
// ./js/lang/en/general.js